import superMeta from '../_PARAM/metaParamNode.mjs'

export default {
    ...superMeta,
    name: '返回参数',
    type: 'REP',
}
